// extracted by mini-css-extract-plugin
export default {"class":"Class_class__w-oxp","addSampleTitle":"Class_addSampleTitle__ZL3cm","buttons":"Class_buttons__MsRgi"};